














import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {UserTracks} from "@share/web-conferences/types/UserTracks";
import {UserProfile} from "@api/models/UserProfile";
import UserIcon from "@share/web-conferences/components/UserIcon.vue";
import NoMicIcon from '../../../assets/svg/no-mic.svg';
import {getWidth} from "@share/web-conferences/helpers/VideoWidthHelper";
import {isUserSharing} from "@share/web-conferences/helpers/IsShareScreen";
import { EventBus } from "@common/EventBus";
import { NetworkQuality as NetworkQualityStruct } from "agora-rtc-sdk-ng";
import QualityIndicator from "@share/web-conferences/components/common/QualityIndicator.vue";
import { AgoraNetworkQuality } from "../agora/AgoraNetworkQuality";

@Component({
  name: 'VideoStream',
  components: { UserIcon, NoMicIcon, QualityIndicator }
})
export default class VideoStream extends Vue {
  @Prop({required: true}) userTracks: UserTracks;
  @Prop({required: true}) audioState: boolean;
  @Prop({required: true}) videoState: boolean;
  @Prop({required: true, default: null}) userProfile: UserProfile | null;
  @Prop({required: true}) volume: number;
  @Prop({required: true}) totalTracksNumber: number;
  @Prop({default: false}) isMuted: boolean;
  @Prop({ default: false }) isThereScreenSharing: boolean;
  @Prop({ default: null }) sharingScreenTracks: UserTracks;
  @Prop({}) quality: NetworkQualityStruct | undefined;

  get isMicEnabled(): boolean {
    return !!(this.userTracks.audio && this.audioState);
  }

  get isVideoEnabled(): boolean {
    return !!(this.userTracks.video && this.videoState);
  }

  get profileLabel(): string | undefined {
    return [this.userProfile?.fullName, this.userProfile?.company, this.userProfile?.position].filter(item => item).join(', ');
  }

  get isSpeaking(): boolean {
    return this.volume >= 2 && this.isMicEnabled;
  }

  get width() {
    return getWidth(this.totalTracksNumber);
  }

  get isSharingUser() {
    return this.sharingScreenTracks && isUserSharing(this.userTracks.uid, this.sharingScreenTracks.uid);
  }

  get averageNetworkQuality() {
    return this.quality ? AgoraNetworkQuality.getAverageNetworkQuality(this.quality) : undefined;
  }

  get showQuality() {
    return this.averageNetworkQuality && this.averageNetworkQuality > 3;
  }

  get currentUserId() {
      return this.$store.state.session.userId;
  }

  get isCurrentUser() {
      return this.currentUserId == this.userProfile?.userId;
  }

  get classes() {
    return {
      "is-speaking": this.isSpeaking,
      "is-with-video": this.isVideoEnabled ,
      "is-small": this.isThereScreenSharing,
      "is-sharing": this.isSharingUser,
      "is-one-row": this.totalTracksNumber <= 8
    }
  }

  get styles(): Record<string, string> {
    let styles: any = {};
    if (!this.isThereScreenSharing) {
      styles = {
          width: this.userTracks.isScreenShare ? '100%' : `calc(${this.width}% - 6px)`
      }

      if (this.userTracks.isScreenShare) {
        styles['height'] = '100%';
        styles['margin'] = 0;
      }
    }

    return styles;
  }

  get needToPlayAudio() {
    return !this.isMuted && this.userTracks.audio && !this.userTracks.isLocal
  }

  @Watch('isVideoEnabled')
  onIsVideoEnabledChanged(oldValue: boolean, newValue: boolean) {
    if (oldValue != newValue) {return;}

    if (this.isVideoEnabled) {
      this.playVideo();
    }
    else {
      this.stopVideo();
    }
  }

  updated() {
    this.play();
  }

  mounted() {
    this.play();
  }

  // we thought that mirroring is a falsy behaviour and turned it off initially,
  // but later it was decided that default behaviour with mirroring only remote tracks is correct
  playVideo() {
    if (this.userTracks.video) {
      this.userTracks.video.play(this.$refs['video'] as HTMLElement, {
        // mirror: false,
        fit: this.userTracks.isScreenShare ? 'contain' : 'cover'
      });
    }
  }

  playAudio() {
    if (this.needToPlayAudio) {
      this.userTracks?.audio?.play();
    }
  }

  stopVideo() {
    this.userTracks.video?.stop();
  }

  play() {
    this.playVideo();
    this.playAudio();
  }

  async openChat() {
    if(!this.isCurrentUser && this.userProfile?.userId) {
      EventBus.$emit("showChatByUserId", this.userProfile?.userId)
    }
  }
}

